// @flow
import React from "react";
import { Icon } from "../";
import styles from "./Button.scss";

type Props = {
  variant: string,
  className: React.Node,
  children: React.Node
};

const Button = (props: Props) => {
  const { variant, className, icon, ...rest } = props;
  const variantClass = variant ? styles[variant] : styles.primary;
  const concatClass = className || "";
  const content = props.children || "Button";
  return (
    <button
      {...rest}
      className={`${styles.ripple} ${variantClass} ${concatClass} ${
        icon ? styles.withIcon : ""
      }`}
    >
      {icon ? <Icon name={icon} /> : ""}
      {content}
      <div className={styles.active} />
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/button/Button.js